import { EQUIPMENT } from '../../../core/constants/landing';
import { WHATSAPP_MESSAGES } from '../../../core/constants/site';
import { buildWhatsAppUrl } from '../../../core/utils/whatsapp';
import { IconWhatsApp } from '../../../common/icons';
import Reveal from '../../../common/components/Reveal/Reveal';
import ViewfinderFrame from '../../../common/components/ViewfinderFrame/ViewfinderFrame';

import '../styles/equipment.css';

export default function Equipment() {
    return (
        <section id="equipos" className="equipment section section--elevated" aria-labelledby="equipment-title">
            <div className="equipment__inner container">
                <Reveal as="figure" className="equipment__figure">
                    <picture>
                        <source
                            type="image/webp"
                            srcSet="/img/equipment-camera-640.webp 640w, /img/equipment-camera-960.webp 960w"
                            sizes="(max-width: 899px) 100vw, 560px"
                        />
                        <img
                            className="equipment__image"
                            src="/img/equipment-camera-960.jpg"
                            width="960"
                            height="640"
                            alt="Cámara de video profesional con el monitor lateral encendido durante una grabación"
                            loading="lazy"
                            decoding="async"
                        />
                    </picture>
                    <ViewfinderFrame />
                </Reveal>

                <Reveal className="equipment__content">
                    <p className="eyebrow">Alquiler</p>
                    <h2 id="equipment-title" className="section__title">Equipos de cine y TV</h2>
                    <p className="section__lead">{EQUIPMENT.lead}</p>

                    <ul className="equipment__list">
                        {EQUIPMENT.categories.map(category => (
                            <li className="equipment__item" key={category}>{category}</li>
                        ))}
                    </ul>

                    <a
                        className="button button--ghost equipment__cta"
                        href={buildWhatsAppUrl(WHATSAPP_MESSAGES.rental)}
                        target="_blank"
                        rel="noopener"
                    >
                        <IconWhatsApp />
                        {EQUIPMENT.cta}
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
